module.exports = __webpack_public_path__ + "static/media/数字孪生行业应用-智慧矿山-01.b20cb959.jpg";